import {t} from '../../../common/getTranslations';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../Dialog';

export function NonstopWatchingDialog({
  isOpen,
  onClose,
  onClickConfirm,
  isMobile,
  isNonstopWatching,
  isCashTypeViewer,
  isShortsDrama,
}: {
  isOpen: boolean;
  onClose: () => void;
  onClickConfirm: () => void;
  isMobile: boolean;
  isNonstopWatching?: boolean;
  isCashTypeViewer?: boolean;
  isShortsDrama?: boolean;
}) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      isMobile={isMobile}
      {...putTiaraObjectProps({
        click: {
          layer1: isCashTypeViewer ? '캐시타입정주행팝업' : '정주행팝업',
        },
        customProps: {
          popup_type: isCashTypeViewer ? '캐시타입정주행팝업' : '정주행팝업',
          viewer_mode: isNonstopWatching ? '정주행모드' : '일반모드',
          ...(isShortsDrama && {
            is_shortdrama: isShortsDrama ? 'y' : undefined,
          }),
        },
      })}
    >
      <Dialog.Dimmed />
      <Dialog.Title>{t('viewer_binge_watch_popup')}</Dialog.Title>
      <Dialog.List>
        <Dialog.Label>{t('viewer_binge_watch_popup_message')}</Dialog.Label>
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e => LOG_CLICK_EVENT('정주행안내_취소_클릭', e, onClose)}
        >
          {t('common_cancel_button')}
        </Dialog.Button>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('정주행안내_확인_클릭', e, onClickConfirm)
          }
          variant={ButtonV2Variant.Primary}
        >
          {t('common_confirm_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
